import { Navigate, Route, Routes } from "react-router-dom";

import { isAuthenticated } from "../utils/auth";

import Sped from "../pages/Reports/Sped/Sped";
import Sales from "../pages/Reports/Sales/Sales";
import Lands from "../pages/Reports/Lands/Lands";
import Debtor from "../pages/Reports/Debtor/Debtor";
import Returns from "../pages/Financial/Returns/Returns";
import Receipts from "../pages/Reports/Receipts/Receipts";
import Simulations from "../pages/Reports/Simulations/Simulations";
import LandsAvailable from "../pages/Reports/LandsAvailable/LandsAvailable";
import { OperacionalFlow } from "../pages/Reports/OperacionalFlow/OperacionalFlow";
import ContractsToReadjust from "../pages/Reports/ContractsToReadjust/ContractsToReadjust";
import ReversalOfInstallments from "../pages/Reports/ReversalOfInstallments/ReversalOfInstallments";
import { ClientsIR } from "../pages/Reports/ClientsIR/ClientsIR";
import { SallesSummary } from "../pages/Reports/SalesSummary/SalesSummary";
import { PaymentStatement } from "../pages/Reports/PaymentStatement/PaymentStatement";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const ReportsRoute = () => (
  <PrivateRoute>
    <Routes>
      <Route
        path="/reversalOfInstallments"
        element={<ReversalOfInstallments />}
      />
      <Route path="/simulations" element={<Simulations />} />
      <Route path="/returns" element={<Returns />} />
      <Route path="/sales" element={<Sales />} />
      <Route path="/receipts" element={<Receipts />} />
      <Route path="/debtor" element={<Debtor />} />
      <Route path="/contractsToReadjust" element={<ContractsToReadjust />} />
      <Route path="/lands" element={<Lands />} />
      <Route path="/landsAvailable" element={<LandsAvailable />} />
      <Route path="/OperacionalFlow" element={<OperacionalFlow />} />
      <Route path="/sped" element={<Sped />} />
      <Route path="/clientsIR" element={<ClientsIR />} />
      <Route path="/sales-summary" element={<SallesSummary />} />
      <Route path="/payment-statement" element={<PaymentStatement />} />
    </Routes>
  </PrivateRoute>
);
